module.exports = __webpack_public_path__ + "static/media/redux.aa0a3376.svg";